// These amounts are yuan returned by Douyin. Do not infer missing values.
export function officialNumber(value) {
  if (value === null || value === undefined || value === "" || typeof value === "boolean") return null;
  const number = Number(value);
  return Number.isFinite(number) ? number : null;
}

export function normalizeOfficialIncome(row, account) {
  const hosts = { douyin: "抖音", douyin_lite: "抖音极速版", toutiao: "今日头条", toutiao_lite: "头条极速版", xigua: "西瓜视频", fanqie: "番茄小说", pipixia: "皮皮虾", hongguo: "红果", novel: "番茄畅听", fanqie_music: "番茄音乐", qishui: "汽水音乐" };
  const channels = { AD: "广告", Star: "星图-口价", Pop: "发行人", Nature: "自然", organic: "自然" };
  const ads = { banner: "Banner", interstitial: "插屏", video: "激励视频", reward_video: "激励视频" };
  const systems = { ios: "iOS", android: "安卓", open_harmony: "鸿蒙" };
  return {
    date: row.date, host: account, hostApp: hosts[row.host_app] || row.host_app || "全部",
    os: systems[row.os] || row.os || "全部", channel: channels[row.channel] || row.channel || "全部",
    adType: ads[row.ad_type] || row.ad_type || "全部",
    requestPv: officialNumber(row.request_pv), displayPv: officialNumber(row.show_pv), clickPv: officialNumber(row.click_pv),
    clickRate: officialNumber(row.click_rate), ecpm: officialNumber(row.ecpm),
    preIncome: officialNumber(row.income_before_share), postIncome: officialNumber(row.income_after_share),
    source: "抖音官方"
  };
}

export function sumOfficial(rows, field) {
  if (!rows.length || rows.some(row => officialNumber(row[field]) === null)) return null;
  return rows.reduce((total, row) => total + Number(row[field]), 0);
}
